import { render } from "./modal_panierscango_resto.vue?vue&type=template&id=7b1623e4&scoped=true"
import script from "./modal_panierscango_resto.vue?vue&type=script&lang=js"
export * from "./modal_panierscango_resto.vue?vue&type=script&lang=js"

import "./modal_panierscango_resto.vue?vue&type=style&index=0&id=7b1623e4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1623e4"]])

export default __exports__